import MaterialFormLineItem from './MaterialFormLineItem';
import {Form, IForm } from './Form';

interface IMaterialForm {
    id?: number;
    shipToCenterId?: number;
    shipToUserId?: number;
    status?: string;
    items?: MaterialFormLineItem[];
    requiresDirectorApproval?: boolean;
    uniqueId?: string;
    submittedUserId?: number;
    submitted?: Date;
    updatedByUserId?: number;
    updated?: Date;
    jobCorpsCenterId?: number;
    isActive?: boolean;
    type?: string;
    actionLevel?: string;
    action?: string;
}

class MaterialForm extends Form implements IMaterialForm {
    public shipToCenterId?: number;
    public shipToUserId?: number;
    public items: MaterialFormLineItem[];
    public requiresDirectorApproval?: boolean;

    constructor(m: IMaterialForm = {}) {
        super({
            id: m.id,
            uniqueId: m.uniqueId,
            status: m.status,
            submitted: m.submitted,
            submittedUserId: m.submittedUserId,
            updatedByUserId: m.updatedByUserId,
            updated: m.updated,
            jobCorpsCenterId: m.jobCorpsCenterId,
            type: m.type,
            actionLevel: m.actionLevel,
            action: m.action
        } as IForm);
        this.shipToCenterId = m.shipToCenterId;
        this.shipToUserId = m.shipToUserId;
        this.items = m.items !== undefined ? m.items : [];
        this.requiresDirectorApproval = m.requiresDirectorApproval;
        this.isActive = m.isActive;
    }

    get shipToCenter(): boolean {
        if (this.shipToUserId !== undefined && (this.shipToCenterId === undefined || this.shipToCenterId === -1)) {
            return false;
        } else {
            return true;
        }
    }
}

export default MaterialForm;
export { MaterialForm, IMaterialForm };
